import React from 'react';
import { FiShield } from 'react-icons/fi';
import { SectionTitle, InfoField, MissingDataSlot } from '../shared/ModalHelpers';

const AdminDetailsCard = ({ admin }) => (
    <div className={`space-y-6 p-8 rounded-[2.5rem] border transition-all ${admin?.nome ? 'bg-[var(--bg-card)] border-[var(--border-color)]' : 'bg-amber-500/5 border-amber-500/20'}`}>
        <SectionTitle icon={FiShield} title="ADMINISTRADOR" />
        {admin?.nome ? (
            <div className="space-y-5">
                <InfoField label="Nome Completo" value={admin.nome} bold font="text-lg" />
                <div className="grid grid-cols-2 gap-4">
                    <InfoField label="CPF" value={admin.cpf} font="font-mono text-xs" />
                    <InfoField label="Telefone" value={admin.telefone} />
                </div>
                <InfoField label="E-mail Corporativo" value={admin.email} lowercase />
            </div>
        ) : (
            <MissingDataSlot label="Dados do Administrador não informados" />
        )}
    </div>
);

export default AdminDetailsCard;